import {
  Activity,
  ChartGantt,
  FileText,
  LifeBuoy,
  List,
  Plus,
  ScanEye,
  type LucideIcon,
} from 'lucide-react';

import { ROUTE_PATHS } from '@/config/constants';

export interface AdminCardAction {
  label: string;
  path: string;
  icon: LucideIcon;
  variant?: 'default' | 'outline';
}

export interface AdminCardConfig {
  id: string;
  title: string;
  description: string;
  // Name shown in the header when the card is favorited.
  menuLabel: string;
  // The first action is also where the header link points.
  actions: AdminCardAction[];
}

export const ADMIN_CARDS: AdminCardConfig[] = [
  {
    id: 'onboarding',
    title: 'Onboarding Dashboard',
    description: 'View and manage customer metrics',
    menuLabel: 'Onboarding',
    actions: [
      {
        label: 'View Onboarding',
        path: ROUTE_PATHS.ADMIN_ONBOARDING,
        icon: Activity,
      },
    ],
  },
  {
    id: 'customers',
    title: 'Customer Management',
    description: 'Create and manage customer accounts',
    menuLabel: 'Customers',
    actions: [
      {
        label: 'View All Customers',
        path: ROUTE_PATHS.ADMIN_CUSTOMERS,
        icon: List,
        variant: 'outline',
      },
      {
        label: 'Create New Customer',
        path: ROUTE_PATHS.ADMIN_CUSTOMERS_CREATE,
        icon: Plus,
      },
    ],
  },
  {
    id: 'users',
    title: 'User Management',
    description: 'Create and manage user accounts',
    menuLabel: 'Users',
    actions: [
      {
        label: 'View All Users',
        path: ROUTE_PATHS.ADMIN_USERS,
        icon: List,
        variant: 'outline',
      },
      {
        label: 'Create New User',
        path: ROUTE_PATHS.ADMIN_USERS_CREATE,
        icon: Plus,
      },
    ],
  },
  {
    id: 'taxonomy',
    title: 'Taxonomy Management',
    description: 'Create and manage taxonomies',
    menuLabel: 'Taxonomy',
    actions: [
      {
        label: 'Create/Manage Taxonomy',
        path: ROUTE_PATHS.ADMIN_TAXONOMY,
        icon: ChartGantt,
      },
    ],
  },
  {
    id: 'audit-logs',
    title: 'Audit Logs',
    description: 'Track and analyze system activities',
    menuLabel: 'Audit Logs',
    actions: [
      {
        label: 'View Audit Logs',
        path: ROUTE_PATHS.ADMIN_AUDIT_LOGS,
        icon: FileText,
      },
    ],
  },
  {
    id: 'prompts',
    title: 'Prompt Management',
    description: 'Create and manage prompts',
    menuLabel: 'Prompts',
    actions: [
      {
        label: 'View Prompts and Queries',
        path: ROUTE_PATHS.ADMIN_PROMPTS,
        icon: FileText,
      },
    ],
  },
  {
    id: 'models',
    title: 'Model Management',
    description: 'Create and manage models',
    menuLabel: 'Models',
    actions: [
      { label: 'View Models', path: ROUTE_PATHS.ADMIN_MODELS, icon: FileText },
    ],
  },
  {
    id: 'voice-tone',
    title: 'Voice Tone Exports',
    description: 'Create and track training file exports',
    menuLabel: 'Voice Tone',
    actions: [
      {
        label: 'View Exports',
        path: ROUTE_PATHS.ADMIN_VOICE_TONE_EXPORTS,
        icon: FileText,
      },
    ],
  },
  {
    id: 'vision-monitor',
    title: 'Vision Monitor',
    description: 'Follow how products are read by Vision',
    menuLabel: 'Vision Monitor',
    actions: [
      {
        label: 'Open Vision Monitor',
        path: ROUTE_PATHS.ADMIN_VISION_MONITOR,
        icon: ScanEye,
      },
    ],
  },
  {
    id: 'tickets',
    title: 'Support Tickets',
    description: 'View and respond to support tickets from customers',
    menuLabel: 'Tickets',
    actions: [
      {
        label: 'Open Tickets',
        path: ROUTE_PATHS.ADMIN_TICKETS,
        icon: LifeBuoy,
      },
    ],
  },
];
